import React, { memo, Fragment } from 'react';
import { createUseStyles, Icon, Text, FilePicker, useTheme } from '@Sage/hoi-poi-ui';

import { useWeb5Context } from 'lib/Web5Context';

import StepContent from '../StepContent';

import ExcelIcon from '../../icons/ExcelIcon';
import UploadIcon from '../../icons/UploadIcon';
import { FILE_TYPES } from '../../constants';

import styles from './styles';

const useStyles = createUseStyles(styles, 'UploadFile');

const UploadFile = ({ entityLabel, uploadDescriptionLabel, file, onRemove, onDrop }) => {
    const classes = useStyles();
    const { t } = useWeb5Context();
    const theme = useTheme();

    return (
        <Fragment>
            <div className={classes.stepWrapper}>
                <StepContent>
                    <div className={classes.row}>
                        <div className={classes.rowIcon}>
                            <UploadIcon />
                        </div>
                        <Text bold>{t(uploadDescriptionLabel, [entityLabel])}</Text>
                    </div>
                    {file && (
                        <div className={classes.file}>
                            <div className={classes.fileContainer}>
                                <div className={classes.excelIcon}>
                                    <ExcelIcon />
                                </div>
                                <Text
                                    className={classes.fileName}
                                    type="badges"
                                    color={theme.colors.textLight.secondary}
                                >
                                    {file.name}
                                </Text>
                                <Icon size="small" name="close" onClick={onRemove} />
                            </div>
                        </div>
                    )}
                    {!file && (
                        <FilePicker
                            title={t('cfm_label_drag_and_drop_here')}
                            buttonLabel={t('cfm_action_select_file')}
                            onDrop={onDrop}
                            files={file || []}
                            accept={FILE_TYPES}
                            limit={1}
                        />
                    )}
                </StepContent>
            </div>
        </Fragment>
    );
};

UploadFile.propTypes = {};

export default memo(UploadFile);
